import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { TranslateModule } from '@ngx-translate/core';
import { EventMapEffects } from './effects/event-map.effects';

@NgModule({
  imports: [
    CommonModule,
    // 💡 關鍵：子模組專用的多國語系配置
    TranslateModule.forChild(), 
    // 💡 關鍵：將 Effect 註冊在這個功能層級
    EffectsModule.forFeature([EventMapEffects])
  ]
})
export class EventMapModule { }